import React from "react";
import { Trans, useTranslation } from "react-i18next";

const HtmlTrans = ({
  i18nKey,
  components,
}: {
  i18nKey: string;
  components?: Record<string, React.ReactNode>;
}) => {
  const { t } = useTranslation();

  return (
    <Trans
      i18nKey={t(i18nKey)}
      components={{
        ol: (
          <ol className="list-disc list-inside my-4 ml-2 marker:font-bold marker:text-gray-300" />
        ),
        li: <li />,
        h3: <h3 className="font-extrabold text-gray-900 text-2xl  mt-4 mb-2" />,
        h4: <h4 className="font-extrabold text-gray-600 text-xl mt-4 mb-2"/>,
        em: <em />,
        u: <u />,
        strong: <strong />,
        olg: <span className="text-ol-gradient" />,
        ...components,
      }}
    />
  );
};

export default HtmlTrans;
